<template>
  <v-input
    v-bind="$attrs"
    :value="value"
    class="p-social-media-channel-selector"
  >
    <div>
      <label
        v-if="label"
        v-text="label"
        class="p-label v-label"
      ></label>

      <v-item-group
        v-model="model"
        class="d-flex"
        multiple
        group
      >
        <v-item
          v-for="channel of socialMediaChannels"
          :key="channel.id"
          :value="channel.id"
          v-slot="{ active, toggle }"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div
                v-on="on"
                :class="{ 'p-social-media-channel-selector__item--active': active }"
                class="p-social-media-channel-selector__item"
                @click="toggle"
              >
                <p-social-media-channel-avatar
                  :social-media-channel="channel"
                ></p-social-media-channel-avatar>
                <p-social-media-icon
                  :id="channel.socialMediaId"
                  class="p-social-media-channel-selector__item-icon"
                ></p-social-media-icon>
              </div>
            </template>
            <span v-text="channel.name"></span>
          </v-tooltip>
        </v-item>

        <!-- DIV below fixes the issue of misordering items after adding a new one -->
        <div></div>

        <v-menu
          nudge-bottom="30"
          close-on-click
          close-on-content-click
        >
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              v-text="$t('components.socialMediaChannelSelector.addChannel')"
              :class="{ 'ml-4 mt-6': socialMediaChannels.length }"
              class="p-social-media-channel-selector__add-link"
            ></a>
          </template>
          <v-list dense>
            <v-list-item
              v-for="socialMedia of socialMedias"
              :key="socialMedia.id"
              @click="addSocialMediaChannel(socialMedia.id)"
            >
              <v-list-item-icon>
                <p-social-media-icon
                  :id="socialMedia.id"
                ></p-social-media-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ socialMedia.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-item-group>
    </div>
  </v-input>
</template>


<script>
import PSocialMediaIcon from './PSocialMediaIcon'
import PSocialMediaChannelAvatar from './PSocialMediaChannelAvatar'


export default ({
  inheritAttrs: false,


  components: {
    PSocialMediaIcon,
    PSocialMediaChannelAvatar
  },


  props: {
    value: {
      type: Array
    },
    socialMediaChannels: {
      type: Array
    },
    socialMedias: {
      type: Array
    },
    label: {
      type: String
    }
  },


  computed: {
    model: {
      get () {
        return this.value || []
      },
      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  },


  methods: {
    addSocialMediaChannel (socialMediaId) {
      this.$emit('add', socialMediaId)
    }
  }
})
</script>
